// ABOUTME: Context and hook opening the app-wide bulk change dialog from anywhere (node action, list view, snackbar).
// ABOUTME: The dialog itself lives in FindReplaceDialogHost, mounted once in App.tsx.

import { SearchFilter } from '@src/__generated__/types';
import { createContext, useContext } from 'react';

/** The initial values of the Scope step; all optional, the user completes the scope in the dialog. */
export type FindReplaceDialogRequest = {
    /** Pre-fills and locks the hierarchy. */
    hierarchyId?: string;
    /** The branch the scope is limited to (the node of the node action). */
    rootNodeId?: string;
    /** The filters of the list view the dialog was opened from. */
    filters?: SearchFilter[];
    /** Labels of the path to the branch root, shown as the branch. */
    breadcrumb?: string[];
    /** Opens the preview or result of an existing run instead of a new bulk change. */
    runId?: string;
};

export type FindReplaceDialogContextValue = {
    open: (request: FindReplaceDialogRequest) => void;
};

export const FindReplaceDialogContext = createContext<FindReplaceDialogContextValue | null>(null);

export function useFindReplaceDialog(): FindReplaceDialogContextValue {
    const value = useContext(FindReplaceDialogContext);
    if (!value) throw new Error('useFindReplaceDialog must be used inside FindReplaceDialogHost');
    return value;
}

/** The dialog context, or null outside FindReplaceDialogHost (e.g. a widget rendered in isolation). */
export function useOptionalFindReplaceDialog(): FindReplaceDialogContextValue | null {
    return useContext(FindReplaceDialogContext);
}
